import { Box, Stack, Typography } from "@mui/material";
import { SLOT_STATUS_META } from "../../pages/trainer/trainerUtils";

export default function TrainerPlanLegend() {
  return (
    <Stack direction="row" spacing={1.5} sx={{ flexWrap: "wrap", rowGap: 0.5 }}>
      {Object.entries(SLOT_STATUS_META).map(([key, meta]) => (
        <Stack key={key} direction="row" spacing={0.5} alignItems="center">
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              backgroundColor: meta.border,
            }}
          />
          <Typography variant="caption" color="text.secondary">
            {meta.label}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
}
